import { useStaticQuery, graphql } from "gatsby";
import SlantSection from "../../components/Slant/Slant";
import { Flex } from "theme-ui";
import { useState } from "react";
import Icon from "../../components/Icons/Icon";

const ReferBenefitsTabs = () => {
  const [tabSelected, setTabSelected] = useState(0);
  const data = useStaticQuery(graphql`
    query ReferBenefitsTabsQuery {
      allDataJson {
        edges {
          node {
            Refer {
              ReferBenefitsTabs {
                backgroundColor
                tabs {
                  tab
                  heading {
                    text
                    color
                  }
                  list {
                    icon
                    subText {
                      text
                      color
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  const {
    ReferBenefitsTabs: { tabs, backgroundColor },
  } = data.allDataJson.edges[0].node.Refer;

  return (
    <SlantSection
      variant="full"
      background={backgroundColor}
      sx={{
        alignItems: "center",
        flexDirection: "column",
        pb: [6, null, null, 8],
      }}
    >
      <Flex
        data-sal={"slide-up"}
        data-sal-easing="easeOutQuart"
        data-sal-duration={1000}
        data-sal-delay={"100"}
        sx={{
          flexWrap: "wrap",
          justifyContent: "center",
          px: [3, 0],
          mt: [3],
        }}
      >
        {tabs.map((tab: any, i: number) => (
          <div
            key={i}
            onClick={() => setTabSelected(i)}
            sx={{
              bg: tabSelected == i ? "green" : "white",
              color: tabSelected == i ? "white" : "darkBlue",
              px: 4,
              textTransform: "uppercase",
              m: 1,
              cursor: "pointer",
            }}
          >
            <h2
              sx={{
                fontSize: [18, null, null, null, 22],
              }}
            >
              {tab.tab}
            </h2>
          </div>
        ))}
      </Flex>
      <div
        data-sal={"slide-up"}
        data-sal-easing="easeOutQuart"
        data-sal-duration={1000}
        data-sal-delay={"100"}
      >
        <h2
          sx={{
            color: tabs[tabSelected].heading.color,
            textAlign: "center",
            px: [3, null, null, 7],
            py: 4,
          }}
        >
          {tabs[tabSelected].heading.text}
        </h2>
        <Flex
          sx={{
            justifyContent: "center",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          {tabs[tabSelected].list.map((t, i) => (
            <Flex
              key={i}
              sx={{
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                maxWidth: [300, null, null, 300],
                mx: [3, 4],
              }}
            >
              <Flex
                sx={{
                  height: 120,
                  alignItems: "center",
                  justifyContent: "center",
                  my: 3,
                }}
              >
                <Icon icon={t.icon} size={[100, 120]} />
              </Flex>
              <p
                sx={{
                  color: t.subText.color,
                }}
              >
                {t.subText.text}
              </p>
            </Flex>
          ))}
        </Flex>
      </div>
    </SlantSection>
  );
};

export default ReferBenefitsTabs;
